import { useEffect } from 'react';

/**
 * usePageTitle, sets the browser tab title to:
 *   "<page> · 2120.money, Financial Clarity for a Meaningful Life"
 *
 * Pass `null` or empty for marketing-style pages to use just the base title.
 */
export default function usePageTitle(page) {
  useEffect(() => {
    const tail = '2120.money — Financial Clarity for a Meaningful Life';
    document.title = page ? `${page} · ${tail}` : tail;
  }, [page]);
}
